<template>
  <div class="inventory m-16" style="left:70px;width:93%">
    <LoaderPopover v-if="$store.state.loader_popup" />
    <Popover v-if="remove_popup" service_type="" :popup_type="popup_type" :serv_index ="fake_serv_index"  @closePopUp="remove_popup = false" @removeService="delete_product()" />
    <div class='container-fluid inventory_view' :style="height_size">
      <div class="row pt-4">     
        <div class="col-6">
          <p class="pull-left font-24 font-weight-500">Products</p>
        </div>
        <div class="col" v-if="(!products_exists_in_store)"></div>
        <div  :class="search_column" v-else>
          <div class="row">
            <div class="col-9 col-lg-9 col-md-8 pr-1 change_width">
              <div class="inputs pull-right">
                <input type="text" class="form-control" v-model="search_product" placeholder="Search for products with name" @input="onchange_get_products()">
                <span class="usericonbox">
                  <i class="fa fa-search ml-2 ash" v-if="!search_product.length"></i>
                  <a @click="remove_search_text" v-else><img class="pull-right point_cursor search_field_icon ml-2 mr-1 mb-1" src="../assets/images/icons/close_icon.svg"></a>
                  </span>
              </div>
            </div>
            <div class="col-3 col-lg-3 col-md-4 pl-0" v-if="products_exists_in_store">
               <button class="btn btn-rounded btn-sm btn-blue pull-right py-auto" @click="new_product('New Product')">Add Product</button>
            </div>
          </div>
        </div>  
        <!-- <div class="col" v-if="search_column == 'col-4 col-sm-4 col-lg-4 .col-md-4 .col-xl-4 pr-0'">
         
        </div> -->
      </div>
      <div v-if="has_products" class="pb-3">
        <div class="products_table">
        <div class="row table_header py-3 m-auto" style="width:100%">
          <div class="col-4">
            <p class="center pl-5 font-18 m-0 font-weight-600">Product Name</p>
          </div>
          <div class="col-2">
            <p class="text-center font-18 m-0 font-weight-600">Quantity</p>
          </div>
          <div class="col-2">
            <p class="float-left font-18 m-0 font-weight-600 pl-3">SKU</p>
          </div>
          <div class="col-2">
            <p class="text-center font-18 m-0 font-weight-600">Price</p>
          </div>
          <div class="col-2">
            <p class="text-center font-18 m-0 font-weight-600">Actions</p>
          </div>
        </div> 
        <!-- <div class="row"> -->
          <draggable v-model="products_list" ghost-class="ghost" @end="onEnd" style="cursor: all-scroll;">
            <transition-group type="transition" name="flip-list">
              <div class="sortable" :id="product.product_id" v-for="(product,index) in products_list" :key="product.product_id">
                <p class="m-0" style="visibility: hidden;height:0px">{{product.product_name}}</p>
                <div class="row products_row m-auto">
                  <div class="col-4">
                    <div class="row">
                    <img class="pl-2 my-auto" src="../assets/images/icons/align-justify.svg" height="40" width="40">
                    <img class="p-2 image-rounded" v-if="product.product_default_image.product_thumbnail_url" :src="product.product_default_image.product_thumbnail_url">
                    <img v-else class="p-2 image-rounded" src="../assets/images/icons/products_in_box.svg">
                    <p class="font-18 my-auto">{{product.product_name}}</p>
                    </div>
                  </div>
                  <!-- <div class="col-4 pl-1">
                   
                  </div> -->
                  <div class="col-2">
                    <p class="text-center font-18 py-4 mb-0 mt-1">{{product.product_quantity}}</p>
                  </div>
                  <div class="col-2">
                    <p class="float-left font-18 py-4 mb-0 mt-1 pl-3">{{product.product_sku}}</p>
                  </div>
                  <div class="col-2">
                    <p class="text-center font-18 py-4 mb-0 mt-1">${{product.product_sale_price}}
                      <span class="ash font-16" v-if="product.product_price > product.product_sale_price"><s>${{product.product_price}}</s></span>
                    </p>
                  </div>
                  <div class="col-2">
                    <div class="dropdown">
                      <p class="point_cursor text-center font-18 ash font-weight-600 pt-3 mb-0 mt-1" type="text" id="dropdownMenuButton" data-toggle="dropdown">
                        . . .
                      </p>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item point_cursor" @click="edit_product(product.product_id,'Edit Product')">Edit Product</a>
                        <a class="dropdown-item point_cursor" @click="edit_product(product.product_id,'New Product')">Duplicate</a>
                        <a class="dropdown-item point_cursor" @click="delete_popup(product.product_id,index)">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
         
        <!-- </div> -->
      </div>
       <infinite-loading :identifier="search_product" @infinite="get_products_list" v-if="show_scroll_event">
            <template slot="no-more">End of Products</template>
        </infinite-loading>
      </div>
      <div class="row products_icon" v-else>
        <div class="m-auto">
          <img src="../assets/images/products.svg">
        </div>
        <div class="row text-center">
          <p class="m-auto font-24" v-if="!products_exists_in_store">Let’s get Started with Products </p>
          <p class="m-auto font-24" v-else>No  Products Found </p>
          <br>
          <p class="ash pt-2 font-18">Create your products to sell them online and let your customers purchase it with ease. </p>
        </div>
        <div class="pt-4 m-auto">
          <button class="btn btn-rounded btn-lg btn-blue font-16" @click="new_product('New Product')">Add Product</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import InfiniteLoading from 'vue-infinite-loading';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import Popover from '@/components/popover_component.vue';
import axios from 'axios';
export default {
  name: 'inventory',
  props: {
    msg: String
  },
  data(){
      return{
          search_product:'',
          products_list:[],
          old_index:'',
          new_index:'',
          page_number:0,
          show_infinate_scroll:true,
          state:'',
          first_call:true,
          show_scroll_event:true,
          selected_product_id:'',
          selected_product_index:'',
          remove_popup:false,
          fake_serv_index:1,
          popup_type:'delete_product',
          products_exists_in_store:false,
          search_data:false,
          timeout:null

      }
  },
  components: {
            draggable,InfiniteLoading,LoaderPopover,Popover
        },
  created(){
    this.get_products_list();
    this.$session.remove('selected_product_id');
    this.$session.set('product_title','New Product');
  },
  mounted(){
    if(this.$session.has('show_toast_product')){
      var title = this.$session.get('toast_title');
      var message = this.$session.get('toast_message');
      this.$bvToast.toast(`${message}`, {
          title: `${title}`,
          variant: 'success',
          autoHideDelay: 5500,
          solid: true
      })
      this.$session.remove('show_toast_product')
    }
  },
  computed : {
    height_size(){
      var auto ='auto';
        if(this.products_list.length > 0 ) return { "height":auto }
        return {
            height: `${(window.innerHeight)-90}px`,
        }
    },
    search_column(){
      if(this.products_list.length > 0 || this.products_exists_in_store) return 'col-6'
      else return 'col-4 mr-3'
    },
    products_column(){
      if(this.products_list.length > 0) return 'col-6';
      else return 'col-8';
    },
    has_products(){
      if(this.products_list.length > 0) return true
      else return false
    }
    },
    methods:{
      edit_product(product_id,title){
        this.$session.set('selected_product_id',product_id);
        this.new_product(title)
      },
      onEnd(event){
        this.old_index = event.oldIndex;
        this.new_index = event.newIndex;
        var product_order = [];
        for(var index = 0; index < this.products_list.length; index++){
          product_order.push({product_id:this.products_list[index].product_id,product_order:(index+1)})
        }
        axios.post(this.$store.state.api +'v2/products/update_products_order_v2',{
          "store_id":this.$session.get('store_id'),
          "products_order":product_order,
          "updated_by":this.$store.state.user_id
        })
      },
      new_product(title){
        this.$session.set('product_title',title);
         this.$session.set('came_from','inventory');
        this.$router.push('/product')
      },
      remove_search_text(){
        this.search_product = '';
        this.onchange_get_products();
      },
      onchange_get_products(){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>{
            this.products_list = [];
            this.show_scroll_event = true;
            this.page_number = 0;
            this.search_data = true;
            this.get_products_list(this.state);
        },900);
      },
      get_products_list($state){
        this.$store.state.loader_popup = true;
        this.state = $state;
        axios.post(this.$store.state.api +'v2/products/get_products_list_v2',{
            "store_id":this.$session.get('store_id'),
            "search_data":this.search_product,
            "page_number":this.page_number
        }).then(response =>{
          this.$store.state.loader_popup = false;
          response.data.result.forEach(product => {
            if(product.product_name){
              if(product.product_name.length >20){
                product.product_name = product.product_name.substr(0,20)+'...';
              }
            }
          });
          if (response.data.result.length) {
            this.products_exists_in_store = true;
            this.page_number += 1;
            if(this.search_data){
                this.products_list = [];
                this.search_data=false;
            }
            this.products_list.push(...response.data.result);
            if($state){
                $state.loaded()
            }
          } else {
            $state.complete();
            this.show_scroll_event = false
          }
        })
      },
      delete_popup(product_id,index){
        this.selected_product_id = product_id;
        this.remove_popup = true;
        this.selected_product_index = index;
      },
      delete_product(){
        axios.post(this.$store.state.api +'v2/products/delete_product_v2',{
            "store_id" :this.$session.get('store_id'),
            "product_id":this.selected_product_id
        }).then(response => {
            if(response.data.status == 200){
                this.remove_popup = false;
                this.products_list.splice(this.selected_product_index,1);
                if(this.products_list.length == 0 && this.search_product.length == 0)this.products_exists_in_store = false;
            }
        })
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inventory_view{
    background: #ffffff;
    border-radius: 6px;
}
.inputs {
  position: relative;
  text-align: center;
  width:95%;
}
.center{
  transform: translate(-50%,-50%,-50%, -50%);
  position: absolute;
}
.products_row{
  border-bottom:solid 1px #EBEFF2;
  /* border-left: */
}
.products_table{
border: solid 1px #EBEFF2;
}
.table_header{
background-color: #FBFBFB;
border-bottom:solid 1px #EBEFF2;
}
.usericonbox {
  position: absolute;
  top: 0px;
  right: 4px;
  width: 50px;
  height: 34px;
  background-color:transparent;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.inputs input {
  width: 100%;
  text-align: left;
  padding-left: 16px;
  font-size: 1em;
  width:100%;
  border-radius: 20px;
  border: 1px solid #EBEFF2;
}
.fa-search{
  margin-top: 0.65rem !important;
}
.search_field_icon{
   margin-top: 0.50rem !important;
}
.products_icon {
  position: absolute;
  transform: translate(-50%,-38%,-38%,-50%);
  top: 30%;
  left:38%;
  right:38%;
}
.flip-list-move{
  transition: transform 0.5s;
}
.image-rounded{
  border-radius:12px;
  height:80px;
  width:80px;
}
.change_width{
  padding-left: 10%;
}
.ghost{
  border: #EBEFF2 3px solid;
  
}
.sortable-drag{
  opacity: 0;
}
</style>
